import React, { Dispatch, SetStateAction } from 'react';
import BasicModal from '../../../components/BasicModal';
import { translate } from '../../../services/translate';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

interface ModalProps {
    isModalVisible: boolean;
    setModalVisible: Dispatch<SetStateAction<boolean>>;
    videoUrl: string;
}

export default function WatchVideoModal({ videoUrl, isModalVisible, setModalVisible }: ModalProps) {
    const { styles } = useStyles(styleSheet);

    return (
        <BasicModal
            isModalVisible={isModalVisible}
            setModalVisible={setModalVisible}
            title={translate('watchVideo')}
            width='medium'
            mobileHeight='fit'
            disableScrollView
            cancelButton={{
                customText: translate('close'),
            }}
        >
            <video style={styles.videoPlayer} autoPlay controls>
                <source src={videoUrl} type='video/mp4' />
            </video>
        </BasicModal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    videoPlayer: {
        width: '100%',
        maxWidth: 640,
        aspectRatio: 16 / 9,
        backgroundColor: theme.colors.card.background,
    }
}));
